import React from "react";
import { Route, Routes } from "react-router-dom";
import Error404 from "./components/Error404";
import Login from "./screens/Login";
import Logout from "./screens/Logout";
import Main from "./screens/Main";
import Other from "./screens/Other";
import CrmLogin from "./screens/CrmLogin";
import GuestActivity from "./screens/GuestActivity";
import ImportantContact from "./screens/ImportantContact";

export default function Routess() {
  return (
    <Routes>
      <Route exact path="/" element={<Other />} />
      <Route exact path="/:id" element={<Main />} />
      <Route exact path="/Guest-Activity/:id" element={<GuestActivity />} />
      {/* <Route exact path="/login/user/:id" element={<CrmLogin />} /> */}
      <Route exact path="/login" element={<Login />} />
      <Route exact path="/logout" element={<Logout />} />
      <Route
        exact
        path="/important/contact/:id"
        element={<ImportantContact />}
      />
      <Route path="/*" element={<Error404 />} />
    </Routes>
  );
}
